module.exports = __webpack_public_path__ + "img/logo-credsis-redirect.eac75531.svg";